import React from 'react';
import { TAILWIND_CLASSES } from '../../Constants/theme';

/**
 * A modern form button component that follows the Unisoft brand design
 */
const FormButton = ({
  children,
  type = 'button',
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  variant = 'primary', // primary, secondary, outline
  size = 'md', // sm, md, lg
  icon = null,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-3 text-base',
    lg: 'px-6 py-4 text-lg',
  };

  const getButtonClasses = () => {
    let baseClasses = `
      rounded-lg
      font-medium
      transition-all
      duration-300
      flex
      items-center
      justify-center
      gap-2
      shadow-sm
      hover:shadow-md
      ${sizeClasses[size]}
      ${fullWidth ? 'w-full' : ''}
      ${disabled || loading ? 'opacity-70 cursor-not-allowed' : 'transform hover:-translate-y-0.5'}
      ${className}
    `;

    switch (variant) {
      case 'secondary':
        return `${baseClasses} bg-secondary hover:bg-secondaryDark text-white`;
      case 'outline':
        return `${baseClasses} bg-white border-2 border-primary text-primary hover:bg-blue-50`;
      case 'gradient':
      default:
        return `${baseClasses} ${TAILWIND_CLASSES.gradientButton}`;
    }
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={getButtonClasses()}
    >
      {loading ? (
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : icon ? (
        <span className="mr-1">{icon}</span>
      ) : null}
      {children}
    </button>
  );
};

export default FormButton; 